import { render, staticRenderFns } from "./loading.mpx?vue&type=template&id=48be50e2&scoped=true&component=true&componentId=loading29b01cdc"
import script from "./loading.mpx?vue&type=script&lang=js&component=true&componentId=loading29b01cdc"
export * from "./loading.mpx?vue&type=script&lang=js&component=true&componentId=loading29b01cdc"
import style0 from "./loading.mpx?vue&type=style&index=0&id=48be50e2&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m29b01cdc%22%7D&component=true&componentId=loading29b01cdc"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be50e2",
  null
  
)

export default component.exports